export enum NotEligibleReason {
  NOT_ELIGIBLE_REASON_UNSET_TYPE = 'NOT_ELIGIBLE_REASON_UNSET_TYPE',
  NO_BASE_PLAN = 'NO_BASE_PLAN',
  MAX_QUEUE_ALLOWANCE = 'MAX_QUEUE_ALLOWANCE',
  UNPAID = 'UNPAID',
}
